import React, { useState, useCallback, useEffect } from 'react'

import styled from 'styled-components'
import i18n from 'live/services/i18n'
import Filters from '../Filters/Filters'
import debounce from 'lodash.debounce'

type IProp = {
    filters: any
    activeFilters:any
    btnTitle: string
    searchPlaceHolder: string
    hrefNewAsset: string
    showButton: boolean
    disabledFilters?: boolean
    onSearch(query, filtersActive: any): Promise<any>
    onDownload(): Promise<any>
    applyCallbackFilters(filtersActive: any): Promise<any>
}

const Actions = ({ disabledFilters = false, filters, btnTitle, hrefNewAsset, applyCallbackFilters, onSearch, onDownload,activeFilters, searchPlaceHolder, showButton = true }: IProp): JSX.Element => {
    const [state, setState] = useState({ query: '' })
    const [filtersLocal, setFiltersLocal] = useState<any>(filters)
    const [filtersActive, setFiltersActive] = useState<any>({...activeFilters})

    useEffect(() => {        
        setFiltersLocal(filters)
    }, [filters])

    const search = (event: any): void => {
        const { value: nextValue } = event.target
        setState({ ...state, ...{ query: nextValue } })
        debouncedSearch(nextValue, filtersActive)
    }

    const handleSearch = (query: string, filterActive?: any) => {
        onSearch(query, filterActive)
    }

    const debouncedSearch = useCallback(
        debounce((params, filtersActive) => handleSearch(params, filtersActive), 500),
        []
    )

    const searchApi = (filterActive: any) => {        
        setFiltersActive(filterActive)
        applyCallbackFilters(filterActive)
    }

    return (
        <ActionsContainer>
            {showButton &&
                <BtnContainer className="item">
                    <a style={{ padding: '4px 16px' }} href={hrefNewAsset} className="btn btn-primary btn-block">
                        + {i18n(btnTitle)}
                    </a>
                </BtnContainer>
            }
            <SearchContainer className="item">
                <WrapperSearch>
                    <div className="inputgroup">
                        <span className="innericon">
                            <i className="far fa-search"></i>
                        </span>

                        <input
                            name="search"
                            value={state.query}
                            type="text"
                            className="form-control"
                            placeholder={searchPlaceHolder ? searchPlaceHolder : i18n('Search by name, email or phone number')}
                            onChange={search}
                        />
                    </div>
                </WrapperSearch>
            </SearchContainer>
            <FiltersContainer className="item">
                <Filters
                    disabledFilters={disabledFilters}
                    filters={filtersLocal}
                    applyCallback={filterActive => searchApi(filterActive)}
                    removeAll={() => searchApi({})}
                    activeFilters={activeFilters}
                />
            </FiltersContainer>

            {
                onDownload && 
                <DownloadContainer className="item">
                    <button onClick={onDownload} className="btn btn-default btn-block btn-custom">
                        <i className='far fa-download' />
                        {i18n('Download list')}
                    </button>
                </DownloadContainer>
            }
            
        </ActionsContainer>
    )
}

export default React.memo(Actions)

const ActionsContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-top: 24px;

    .item {
        padding: 0 8px;

        &:first-child {
            padding-left: 0;
        }

        &:last-child {
            padding-right: 0;
        }
    }
`

const BtnContainer = styled.div`
    flex: 1;

    a {
        font-size: 15px;
        font-weight: 600;
    }
`

const SearchContainer = styled.div`
    flex: 9;
`

const FiltersContainer = styled.div`
    flex: 1;
`

const DownloadContainer = styled.div`
    flex: 1;

    .btn-custom{
        padding: 5.3px 16px;
        background: #fff;
        color: #37A3EF;
        font-weight: 600;
        font-size: 13px;
        border: 1px solid #c8ccd4;
   }
`

const WrapperSearch = styled.div`
    .inputgroup {
        line-height: 26px;
        position: relative;
    }

    input {
        padding-left: 26px;
    }

    .inputgroup .innericon {
        position: absolute;
        top: 4px;
        left: 8px;
        z-index: 2;
        display: block;
        text-align: center;
        pointer-events: none;
        color: ${({ theme }) => theme['gray-600']};
        font-size: 13;
    }
`
